import { createAction } from 'redux-actions';

const actions = {
  /**
   * [주문] 주문 데이터 변경하기
   */
  SET_DATA: 'order/SET_DATA',
  setData: createAction('order/SET_DATA'),

  /**
   * [주문 전체 리스트] 주문 전체 리스트 요청하기
   */
  GET_ORDER_ALL_LIST_REQUEST: 'order/GET_ORDER_ALL_LIST_REQUEST',
  GET_ORDER_ALL_LIST_SUCCESS: 'order/GET_ORDER_ALL_LIST_SUCCESS',
  getOrderAllList: createAction('order/GET_ORDER_ALL_LIST_REQUEST'),

  /**
   * [주문 전체 리스트] 주문 전체 리스트 엑셀 다운로드 요청하기
   */
  GET_ORDER_ALL_LIST_EXCEL_DOWNLOAD_REQUEST: 'order/GET_ORDER_ALL_LIST_EXCEL_DOWNLOAD_REQUEST',
  GET_ORDER_ALL_LIST_EXCEL_DOWNLOAD_SUCCESS: 'order/GET_ORDER_ALL_LIST_EXCEL_DOWNLOAD_SUCCESS',
  getOrderAllListExcelDownload: createAction('order/GET_ORDER_ALL_LIST_EXCEL_DOWNLOAD_REQUEST'),

  /**
   * [주문 취소 리스트] 주문 취소 리스트 요청하기
   */
  GET_ORDER_CANCEL_LIST_REQUEST: 'order/GET_ORDER_CANCEL_LIST_REQUEST',
  GET_ORDER_CANCEL_LIST_SUCCESS: 'order/GET_ORDER_CANCEL_LIST_SUCCESS',
  getOrderCancelList: createAction('order/GET_ORDER_CANCEL_LIST_REQUEST'),

  /**
   * [주문 취소 리스트] 주문 취소 리스트 엑셀 다운로드 요청하기
   */
  GET_ORDER_CANCEL_LIST_EXCEL_DOWNLOAD_REQUEST: 'order/GET_ORDER_CANCEL_LIST_EXCEL_DOWNLOAD_REQUEST',
  GET_ORDER_CANCEL_LIST_EXCEL_DOWNLOAD_SUCCESS: 'order/GET_ORDER_CANCEL_LIST_EXCEL_DOWNLOAD_SUCCESS',
  getOrderCancelListExcelDownload: createAction('order/GET_ORDER_CANCEL_LIST_EXCEL_DOWNLOAD_REQUEST'),

  /**
   * [주문 반품 리스트] 주문 반품 리스트 요청하기
   */
  GET_ORDER_RETURN_LIST_REQUEST: 'order/GET_ORDER_RETURN_LIST_REQUEST',
  GET_ORDER_RETURN_LIST_SUCCESS: 'order/GET_ORDER_RETURN_LIST_SUCCESS',
  getOrderReturnList: createAction('order/GET_ORDER_RETURN_LIST_REQUEST'),

  /**
   * [주문 반품 리스트] 주문 반품 리스트 엑셀 다운로드 요청하기
   */
  GET_ORDER_RETURN_LIST_EXCEL_DOWNLOAD_REQUEST: 'order/GET_ORDER_RETURN_LIST_EXCEL_DOWNLOAD_REQUEST',
  GET_ORDER_RETURN_LIST_EXCEL_DOWNLOAD_SUCCESS: 'order/GET_ORDER_RETURN_LIST_EXCEL_DOWNLOAD_SUCCESS',
  getOrderReturnListExcelDownload: createAction('order/GET_ORDER_RETURN_LIST_EXCEL_DOWNLOAD_REQUEST'),

  /**
   * [주문 교환 리스트] 주문 교환 리스트 요청하기
   */
  GET_ORDER_EXCHANGE_LIST_REQUEST: 'order/GET_ORDER_EXCHANGE_LIST_REQUEST',
  GET_ORDER_EXCHANGE_LIST_SUCCESS: 'order/GET_ORDER_EXCHANGE_LIST_SUCCESS',
  getOrderExchangeList: createAction('order/GET_ORDER_EXCHANGE_LIST_REQUEST'),

  /**
   * [주문 교환 리스트] 주문 교환 리스트 엑셀 다운로드 요청하기
   */
  GET_ORDER_EXCHANGE_LIST_EXCEL_DOWNLOAD_REQUEST: 'order/GET_ORDER_EXCHANGE_LIST_EXCEL_DOWNLOAD_REQUEST',
  GET_ORDER_EXCHANGE_LIST_EXCEL_DOWNLOAD_SUCCESS: 'order/GET_ORDER_EXCHANGE_LIST_EXCEL_DOWNLOAD_SUCCESS',
  getOrderExchangeListExcelDownload: createAction('order/GET_ORDER_EXCHANGE_LIST_EXCEL_DOWNLOAD_REQUEST'),

  /**
   *  [주문/배송관리] 주문/배송관리 리스트 요청하기
   */
  GET_ORDER_MANAGEMENT_LIST_REQUEST: 'order/GET_ORDER_MANAGEMENT_LIST_REQUEST',
  GET_ORDER_MANAGEMENT_LIST_SUCCESS: 'order/GET_ORDER_MANAGEMENT_LIST_SUCCESS',
  getOrderManagementList: createAction('order/GET_ORDER_MANAGEMENT_LIST_REQUEST'),

  /**
   *  [주문/배송관리] 상품 주문 배송 준비 처리하기
   */
  DELIVERY_PREPARATION_ORDER_MANAGEMENT_REQUEST: 'order/DELIVERY_PREPARATION_ORDER_MANAGEMENT_REQUEST',
  DELIVERY_PREPARATION_ORDER_MANAGEMENT_SUCCESS: 'order/DELIVERY_PREPARATION_ORDER_MANAGEMENT_SUCCESS',
  deliveryPreparation: createAction('order/DELIVERY_PREPARATION_ORDER_MANAGEMENT_REQUEST'),

  /**
   *  [주문/배송관리] 상품 주문 배송 지연처리하기
   */
  DELIVERY_DELAY_ORDER_MANAGEMENT_REQUEST: 'order/DELIVERY_DELAY_ORDER_MANAGEMENT_REQUEST',
  DELIVERY_DELAY_ORDER_MANAGEMENT_SUCCESS: 'order/DELIVERY_DELAY_ORDER_MANAGEMENT_SUCCESS',
  deliveryDelay: createAction('order/DELIVERY_DELAY_ORDER_MANAGEMENT_REQUEST'),

  /**
   *  [주문/배송관리] 상품 주문 엑셀 일괄 발송 처리전 유효성 체크하기
   */
  CHECK_EXCEL_BULK_DELIVERY_DISPATCH_ORDER_MANAGEMENT_REQUEST:
    'order/CHECK_EXCEL_BULK_DELIVERY_DISPATCH_ORDER_MANAGEMENT_REQUEST',
  checkExcelBulkDeliveryDispatch: createAction('order/CHECK_EXCEL_BULK_DELIVERY_DISPATCH_ORDER_MANAGEMENT_REQUEST'),

  /**
   *  [주문/배송관리] 상품 주문 발송 처리전 유효성 체크하기
   */
  CHECK_DELIVERY_DISPATCH_ORDER_MANAGEMENT_REQUEST: 'order/CHECK_DELIVERY_DISPATCH_ORDER_MANAGEMENT_REQUEST',
  checkDeliveryDispatch: createAction('order/CHECK_DELIVERY_DISPATCH_ORDER_MANAGEMENT_REQUEST'),

  /**
   *  [주문/배송관리] 상품 주문 발송 처리하기
   */
  DELIVERY_DISPATCH_ORDER_MANAGEMENT_REQUEST: 'order/DELIVERY_DISPATCH_ORDER_MANAGEMENT_REQUEST',
  DELIVERY_DISPATCH_ORDER_MANAGEMENT_SUCCESS: 'order/DELIVERY_DISPATCH_ORDER_MANAGEMENT_SUCCESS',
  deliveryDispatch: createAction('order/DELIVERY_DISPATCH_ORDER_MANAGEMENT_REQUEST'),

  /**
   *  [주문/배송관리] 판매 취소 전 재고, 상품상태 설정 리스트 가져오기
   */
  GET_CANCEL_ORDER_MANAGEMENT_INFO_LIST_REQUEST: 'order/GET_CANCEL_ORDER_MANAGEMENT_INFO_LIST_REQUEST',
  GET_CANCEL_ORDER_MANAGEMENT_INFO_LIST_SUCCESS: 'order/GET_CANCEL_ORDER_MANAGEMENT_INFO_LIST_SUCCESS',
  getCancelOrderManagementInfoList: createAction('order/GET_CANCEL_ORDER_MANAGEMENT_INFO_LIST_REQUEST'),

  /**
   *  [주문/배송관리] 판매 취소하기
   */
  CANCEL_SALES_ORDER_MANAGEMENT_REQUEST: 'order/CANCEL_SALES_ORDER_MANAGEMENT_REQUEST',
  CANCEL_SALES_ORDER_MANAGEMENT_SUCCESS: 'order/CANCEL_SALES_ORDER_MANAGEMENT_SUCCESS',
  cancelSales: createAction('order/CANCEL_SALES_ORDER_MANAGEMENT_REQUEST'),

  /**
   *  [주문/배송관리] 주문자 정보 수정하기
   */
  EDIT_BUYER_INFO_REQUEST: 'order/EDIT_BUYER_INFO_REQUEST',
  EDIT_BUYER_INFO_SUCCESS: 'order/EDIT_BUYER_INFO_SUCCESS',
  editBuyerInfo: createAction('order/EDIT_BUYER_INFO_REQUEST'),

  /**
   *  [주문/배송관리] 송장 수정하기
   */
  EDIT_DELIVERY_INFO_REQUEST: 'order/EDIT_DELIVERY_INFO_REQUEST',
  editDeliveryInfo: createAction('order/EDIT_DELIVERY_INFO_REQUEST'),

  /**
   *  [주문/배송관리] 전체 엑셀 다운로드
   */
  GET_ALL_ORDER_MANAGEMENT_LIST_EXCEL_DOWNLOAD_REQUEST: 'order/GET_ALL_ORDER_MANAGEMENT_LIST_EXCEL_DOWNLOAD_REQUEST',
  getAllManagementListExcelDownLoad: createAction('order/GET_ALL_ORDER_MANAGEMENT_LIST_EXCEL_DOWNLOAD_REQUEST'),

  /**
   *  [주문/배송관리] 선택 엑셀 다운로드
   */
  GET_SELECTED_ORDER_MANAGEMENT_LIST_EXCEL_DOWNLOAD_REQUEST:
    'order/GET_SELECTED_ORDER_MANAGEMENT_LIST_EXCEL_DOWNLOAD_REQUEST',
  getSelectedManagementListExcelDownLoad: createAction(
    'order/GET_SELECTED_ORDER_MANAGEMENT_LIST_EXCEL_DOWNLOAD_REQUEST',
  ),

  /**
   *  [취소 관리] 취소 관리 리스트 요청하기
   */
  GET_ORDER_CANCEL_MANAGEMENT_LIST_REQUEST: 'order/GET_ORDER_CANCEL_MANAGEMENT_LIST_REQUEST',
  GET_ORDER_CANCEL_MANAGEMENT_LIST_SUCCESS: 'order/GET_ORDER_CANCEL_MANAGEMENT_LIST_SUCCESS',
  getOrderCancelManagementList: createAction('order/GET_ORDER_CANCEL_MANAGEMENT_LIST_REQUEST'),

  /**
   *  [취소 관리] 취소 관리 전체 리스트 엑셀 다운로드 요청하기
   */
  GET_ORDER_CANCEL_MANAGEMENT_ALL_LIST_EXCEL_DOWNLOAD_REQUEST:
    'order/GET_ORDER_CANCEL_MANAGEMENT_ALL_LIST_EXCEL_DOWNLOAD_REQUEST',
  getOrderCancelManagementAllListExcelDownload: createAction(
    'order/GET_ORDER_CANCEL_MANAGEMENT_ALL_LIST_EXCEL_DOWNLOAD_REQUEST',
  ),

  /**
   *  [취소 관리] 취소 관리 선택 리스트 엑셀 다운로드 요청하기
   */
  GET_ORDER_CANCEL_MANAGEMENT_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST:
    'order/GET_ORDER_CANCEL_MANAGEMENT_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST',
  getOrderCancelManagementSelectedListExcelDownload: createAction(
    'order/GET_ORDER_CANCEL_MANAGEMENT_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST',
  ),

  /**
   *  [취소 관리] 취소 거부 요청하기
   */
  REJECT_ORDER_CANCEL_ITEM_DATA_REQUEST: 'order/REJECT_ORDER_CANCEL_ITEM_DATA_REQUEST',
  REJECT_ORDER_CANCEL_ITEM_DATA_SUCCESS: 'order/REJECT_ORDER_CANCEL_ITEM_DATA_SUCCESS',
  rejectOrderCancel: createAction('order/REJECT_ORDER_CANCEL_ITEM_DATA_REQUEST'),

  /**
   *  [취소 관리] 취소 완료 요청 전 상품 또는 옵션의 재고, 상태 설정 리스트 요청하기
   */
  GET_ORDER_CANCEL_ITEM_STOCK_AND_STATUS_DATA_LIST_REQUEST:
    'order/GET_ORDER_CANCEL_ITEM_STOCK_AND_STATUS_DATA_LIST_REQUEST',
  getOrderCancelStockAndStatusList: createAction('order/GET_ORDER_CANCEL_ITEM_STOCK_AND_STATUS_DATA_LIST_REQUEST'),

  /**
   *  [취소 관리] 취소 완료 요청하기
   */
  COMPLETE_ORDER_CANCEL_ITEM_DATA_REQUEST: 'order/COMPLETE_ORDER_CANCEL_ITEM_DATA_REQUEST',
  COMPLETE_ORDER_CANCEL_ITEM_DATA_SUCCESS: 'order/COMPLETE_ORDER_CANCEL_ITEM_DATA_SUCCESS',
  completeOrderCancel: createAction('order/COMPLETE_ORDER_CANCEL_ITEM_DATA_REQUEST'),

  /**
   * 택배사 리스트 가져오기
   */
  GET_DELIVERY_AGENT_LIST_REQUEST: 'order/GET_DELIVERY_AGENT_LIST_REQUEST',
  getDeliveryAgentList: createAction('order/GET_DELIVERY_AGENT_LIST_REQUEST'),

  /**
   *  [취소 관리] 취소 거부 -> 발송 처리하기
   */
  DELIVERY_DISPATCH_ORDER_CANCEL_ITEM_DATA_REQUEST: 'order/DELIVERY_DISPATCH_ORDER_CANCEL_ITEM_DATA_REQUEST',
  DELIVERY_DISPATCH_ORDER_CANCEL_ITEM_DATA_SUCCESS: 'order/DELIVERY_DISPATCH_ORDER_CANCEL_ITEM_DATA_SUCCESS',
  rejectOrderCancelDeliveryDispatch: createAction('order/DELIVERY_DISPATCH_ORDER_CANCEL_ITEM_DATA_REQUEST'),

  /**
   *  [반품 관리] 반품 관리 리스트 요청하기
   */
  GET_ORDER_RETURN_MANAGEMENT_LIST_REQUEST: 'order/GET_ORDER_RETURN_MANAGEMENT_LIST_REQUEST',
  GET_ORDER_RETURN_MANAGEMENT_LIST_SUCCESS: 'order/GET_ORDER_RETURN_MANAGEMENT_LIST_SUCCESS',
  getOrderReturnManagementList: createAction('order/GET_ORDER_RETURN_MANAGEMENT_LIST_REQUEST'),

  /**
   *  [반품 관리] 전체 리스트 엑셀 다운로드 요청하기
   */
  GET_ORDER_RETURN_MANAGEMENT_ALL_LIST_EXCEL_DOWNLOAD_REQUEST:
    'order/GET_ORDER_RETURN_MANAGEMENT_ALL_LIST_EXCEL_DOWNLOAD_REQUEST',
  getOrderReturnManagementAllListExcelDownload: createAction(
    'order/GET_ORDER_RETURN_MANAGEMENT_ALL_LIST_EXCEL_DOWNLOAD_REQUEST',
  ),

  /**
   *  [반품 관리] 선택 리스트 엑셀 다운로드 요청하기
   */
  GET_ORDER_RETURN_MANAGEMENT_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST:
    'order/GET_ORDER_RETURN_MANAGEMENT_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST',
  getOrderReturnManagementSelectedListExcelDownload: createAction(
    'order/GET_ORDER_RETURN_MANAGEMENT_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST',
  ),

  /**
   *  [반품 관리] 반품 수거 완료 요청하기
   */
  COMPLETE_COLLECTION_ORDER_RETURN_ITEM_DATA_REQUEST: 'order/COMPLETE_COLLECTION_ORDER_RETURN_ITEM_DATA_REQUEST',
  COMPLETE_COLLECTION_ORDER_RETURN_ITEM_DATA_SUCCESS: 'order/COMPLETE_COLLECTION_ORDER_RETURN_ITEM_DATA_SUCCESS',
  completeCollectionOrderReturn: createAction('order/COMPLETE_COLLECTION_ORDER_RETURN_ITEM_DATA_REQUEST'),

  /**
   *  [반품 관리] 반품 거부 요청하기
   */
  REJECT_ORDER_RETURN_ITEM_DATA_REQUEST: 'order/REJECT_ORDER_RETURN_ITEM_DATA_REQUEST',
  REJECT_ORDER_RETURN_ITEM_DATA_SUCCESS: 'order/REJECT_ORDER_RETURN_ITEM_DATA_SUCCESS',
  rejectOrderReturn: createAction('order/REJECT_ORDER_RETURN_ITEM_DATA_REQUEST'),

  /**
   *  [반품 관리] 반품 사유 수정하기 전 필요한 데이터 요청하기
   */
  GET_PREPARATION_EDIT_REASON_ORDER_RETURN_ITEM_DATA_REQUEST:
    'order/GET_PREPARATION_EDIT_REASON_ORDER_RETURN_ITEM_DATA_REQUEST',
  getPreparationOrderReturnEditReason: createAction('order/GET_PREPARATION_EDIT_REASON_ORDER_RETURN_ITEM_DATA_REQUEST'),

  /**
   *  [반품 관리] 반품 사유 수정 요청하기
   */
  EDIT_ORDER_RETURN_ITEM_REASON_DATA_REQUEST: 'order/EDIT_ORDER_RETURN_ITEM_REASON_DATA_REQUEST',
  EDIT_ORDER_RETURN_ITEM_REASON_DATA_SUCCESS: 'order/EDIT_ORDER_RETURN_ITEM_REASON_DATA_SUCCESS',
  editOrderReturnReason: createAction('order/EDIT_ORDER_RETURN_ITEM_REASON_DATA_REQUEST'),

  /**
   *  [반품 관리] 반품 승인 요청하기
   */
  COMPLETE_ORDER_RETURN_ITEM_DATA_REQUEST: 'order/COMPLETE_ORDER_RETURN_ITEM_DATA_REQUEST',
  COMPLETE_ORDER_RETURN_ITEM_DATA_SUCCESS: 'order/COMPLETE_ORDER_RETURN_ITEM_DATA_SUCCESS',
  completeOrderReturn: createAction('order/COMPLETE_ORDER_RETURN_ITEM_DATA_REQUEST'),

  /**
   *  [반품 관리] 반품 -> 교환 요청하기
   */
  CHANGE_EXCHANGE_ORDER_RETURN_ITEM_DATA_REQUEST: 'order/CHANGE_EXCHANGE_ORDER_RETURN_ITEM_DATA_REQUEST',
  CHANGE_EXCHANGE_ORDER_RETURN_ITEM_DATA_SUCCESS: 'order/CHANGE_EXCHANGE_ORDER_RETURN_ITEM_DATA_SUCCESS',
  changeReturnToExchange: createAction('order/CHANGE_EXCHANGE_ORDER_RETURN_ITEM_DATA_REQUEST'),

  /**
   *  [반품 관리] 반품 사유, 반품 거부 사유 이미지 요청하기
   */
  GET_ORDER_RETURN_ITEM_ATTACHMENT_DATA_REQUEST: 'order/GET_ORDER_RETURN_ITEM_ATTACHMENT_DATA_REQUEST',
  GET_ORDER_RETURN_ITEM_ATTACHMENT_DATA_SUCCESS: 'order/GET_ORDER_RETURN_ITEM_ATTACHMENT_DATA_SUCCESS',
  getOrderReturnAttachment: createAction('order/GET_ORDER_RETURN_ITEM_ATTACHMENT_DATA_REQUEST'),

  /**
   *  [교환 관리] 교환 관리 리스트 요청하기
   */
  GET_ORDER_EXCHANGE_MANAGEMENT_LIST_REQUEST: 'order/GET_ORDER_EXCHANGE_MANAGEMENT_LIST_REQUEST',
  GET_ORDER_EXCHANGE_MANAGEMENT_LIST_SUCCESS: 'order/GET_ORDER_EXCHANGE_MANAGEMENT_LIST_SUCCESS',
  getOrderExchangeManagementList: createAction('order/GET_ORDER_EXCHANGE_MANAGEMENT_LIST_REQUEST'),

  /**
   *  [교환 관리] 전체 리스트 엑셀 다운로드 요청하기
   */
  GET_ORDER_EXCHANGE_MANAGEMENT_ALL_LIST_EXCEL_DOWNLOAD_REQUEST:
    'order/GET_ORDER_EXCHANGE_MANAGEMENT_ALL_LIST_EXCEL_DOWNLOAD_REQUEST',
  getOrderExchangeManagementAllListExcelDownload: createAction(
    'order/GET_ORDER_EXCHANGE_MANAGEMENT_ALL_LIST_EXCEL_DOWNLOAD_REQUEST',
  ),

  /**
   *  [교환 관리] 선택 리스트 엑셀 다운로드 요청하기
   */
  GET_ORDER_EXCHANGE_MANAGEMENT_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST:
    'order/GET_ORDER_EXCHANGE_MANAGEMENT_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST',
  getOrderExchangeManagementSelectedListExcelDownload: createAction(
    'order/GET_ORDER_EXCHANGE_MANAGEMENT_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST',
  ),

  /**
   *  [교환 관리] 교환 수거 완료 요청하기
   */
  COMPLETE_COLLECTION_ORDER_EXCHANGE_ITEM_DATA_REQUEST: 'order/COMPLETE_COLLECTION_ORDER_EXCHANGE_ITEM_DATA_REQUEST',
  COMPLETE_COLLECTION_ORDER_EXCHANGE_ITEM_DATA_SUCCESS: 'order/COMPLETE_COLLECTION_ORDER_EXCHANGE_ITEM_DATA_SUCCESS',
  completeCollectionOrderExchange: createAction('order/COMPLETE_COLLECTION_ORDER_EXCHANGE_ITEM_DATA_REQUEST'),

  /**
   *  [교환 관리] 교환 거부 요청하기
   */
  REJECT_ORDER_EXCHANGE_ITEM_DATA_REQUEST: 'order/REJECT_ORDER_EXCHANGE_ITEM_DATA_REQUEST',
  REJECT_ORDER_EXCHANGE_ITEM_DATA_SUCCESS: 'order/REJECT_ORDER_EXCHANGE_ITEM_DATA_SUCCESS',
  rejectOrderExchange: createAction('order/REJECT_ORDER_EXCHANGE_ITEM_DATA_REQUEST'),

  /**
   *  [교환 관리] 교환 사유 수정하기 전 필요한 데이터 요청하기
   */
  GET_PREPARATION_EDIT_REASON_ORDER_EXCHANGE_ITEM_DATA_REQUEST:
    'order/GET_PREPARATION_EDIT_REASON_ORDER_EXCHANGE_ITEM_DATA_REQUEST',
  getPreparationOrderExchangeEditReason: createAction(
    'order/GET_PREPARATION_EDIT_REASON_ORDER_EXCHANGE_ITEM_DATA_REQUEST',
  ),

  /**
   *  [교환 관리] 교환 사유 수정 요청하기
   */
  EDIT_ORDER_EXCHANGE_ITEM_REASON_DATA_REQUEST: 'order/EDIT_ORDER_EXCHANGE_ITEM_REASON_DATA_REQUEST',
  EDIT_ORDER_EXCHANGE_ITEM_REASON_DATA_SUCCESS: 'order/EDIT_ORDER_EXCHANGE_ITEM_REASON_DATA_SUCCESS',
  editOrderExchangeReason: createAction('order/EDIT_ORDER_EXCHANGE_ITEM_REASON_DATA_REQUEST'),

  /**
   *  [교환 관리] 택배사 리스트 가져오기
   */
  GET_DELIVERY_AGENT_LIST_FOR_ORDER_EXCHANGE_REQUEST: 'order/GET_DELIVERY_AGENT_LIST_FOR_ORDER_EXCHANGE_REQUEST',
  getDeliveryAgentListForOrderExchange: createAction('order/GET_DELIVERY_AGENT_LIST_FOR_ORDER_EXCHANGE_REQUEST'),

  /**
   *  [교환 관리] 교환 재배송 송장 수정 요청하기
   */
  EDIT_ORDER_EXCHANGE_ITEM_DELIVERY_INFO_REQUEST: 'order/EDIT_ORDER_EXCHANGE_ITEM_DELIVERY_INFO_REQUEST',
  EDIT_ORDER_EXCHANGE_ITEM_DELIVERY_INFO_SUCCESS: 'order/EDIT_ORDER_EXCHANGE_ITEM_DELIVERY_INFO_SUCCESS',
  editOrderExchangeDeliveryInfo: createAction('order/EDIT_ORDER_EXCHANGE_ITEM_DELIVERY_INFO_REQUEST'),

  /**
   *  [교환 관리] 교환 승인 요청하기
   */
  COMPLETE_ORDER_EXCHANGE_ITEM_DATA_REQUEST: 'order/COMPLETE_ORDER_EXCHANGE_ITEM_DATA_REQUEST',
  COMPLETE_ORDER_EXCHANGE_ITEM_DATA_SUCCESS: 'order/COMPLETE_ORDER_EXCHANGE_ITEM_DATA_SUCCESS',
  completeOrderExchange: createAction('order/COMPLETE_ORDER_EXCHANGE_ITEM_DATA_REQUEST'),

  /**
   *  [교환 관리] 교환 -> 반품 요청하기
   */
  CHANGE_RETURN_ORDER_EXCHANGE_ITEM_DATA_REQUEST: 'order/CHANGE_RETURN_ORDER_EXCHANGE_ITEM_DATA_REQUEST',
  CHANGE_RETURN_ORDER_EXCHANGE_ITEM_DATA_SUCCESS: 'order/CHANGE_RETURN_ORDER_EXCHANGE_ITEM_DATA_SUCCESS',
  changeExchangeToReturn: createAction('order/CHANGE_RETURN_ORDER_EXCHANGE_ITEM_DATA_REQUEST'),

  /**
   *  [교환 관리] 교환 사유, 교환 거부 사유 이미지 요청하기
   */
  GET_ORDER_EXCHANGE_ITEM_ATTACHMENT_DATA_REQUEST: 'order/GET_ORDER_EXCHANGE_ITEM_ATTACHMENT_DATA_REQUEST',
  GET_ORDER_EXCHANGE_ITEM_ATTACHMENT_DATA_SUCCESS: 'order/GET_ORDER_EXCHANGE_ITEM_ATTACHMENT_DATA_SUCCESS',
  getOrderExchangeAttachment: createAction('order/GET_ORDER_EXCHANGE_ITEM_ATTACHMENT_DATA_REQUEST'),

  /**
   * [주문 상세] 주문 상세 요청하기
   */
  GET_ORDER_DETAIL_REQUEST: 'order/GET_ORDER_DETAIL_REQUEST',
  GET_ORDER_DETAIL_SUCCESS: 'order/GET_ORDER_DETAIL_SUCCESS',
  getOrderDetailList: createAction('order/GET_ORDER_DETAIL_REQUEST'),

  /**
   *  [주문 상세] 주문 상태 되돌리기 요청하기
   */
  CHANGE_ORDER_ITEM_STATUS_REQUEST: 'order/CHANGE_ORDER_ITEM_STATUS_REQUEST',
  CHANGE_ORDER_ITEM_STATUS_SUCCESS: 'order/CHANGE_ORDER_ITEM_STATUS_SUCCESS',
  changeOrderItemStatus: createAction('order/CHANGE_ORDER_ITEM_STATUS_REQUEST'),

  /**
   *  [주문 상세] 주문 상태 되돌리기 요청하기(구매 확정)
   */
  CHANGE_ORDER_CONFIRMS_STATUS_REQUEST: 'order/CHANGE_ORDER_CONFIRMS_STATUS_REQUEST',
  CHANGE_ORDER_CONFIRMS_STATUS_SUCCESS: 'order/CHANGE_ORDER_CONFIRMS_STATUS_SUCCESS',
  changeOrderConfirmsStatus: createAction('order/CHANGE_ORDER_CONFIRMS_STATUS_REQUEST'),

  /**
   * [주문 반품 상세] 주문 반품 상세 요청하기
   */
  GET_ORDER_RETURN_DETAIL_REQUEST: 'order/GET_ORDER_RETURN_DETAIL_REQUEST',
  GET_ORDER_RETURN_DETAIL_SUCCESS: 'order/GET_ORDER_RETURN_DETAIL_SUCCESS',
  getOrderReturnDetailList: createAction('order/GET_ORDER_RETURN_DETAIL_REQUEST'),

  /**
   * [주문 반품 상세] 주문 반품 환불 완료하기
   */
  SET_COMPLETE_REFUND_ORDER_RETURN_REQUEST: 'order/SET_COMPLETE_REFUND_ORDER_RETURN_REQUEST',
  setCompleteRefundOrderReturn: createAction('order/SET_COMPLETE_REFUND_ORDER_RETURN_REQUEST'),

  /**
   *  [주문상세] 교환 요청하기
   */
  SUBMIT_ORDER_EXCHANGE_REQUEST: 'order/SUBMIT_ORDER_EXCHANGE_REQUEST',
  SUBMIT_ORDER_EXCHANGE_SUCCESS: 'order/SUBMIT_ORDER_EXCHANGE_SUCCESS',
  orderExchangeRequest: createAction('order/SUBMIT_ORDER_EXCHANGE_REQUEST'),

  /**
   *  [주문상세] 반품요청에 필요한 데이터 요청하기
   */
  GET_PREPARATION_ORDER_RETURN_REQUEST: 'order/GET_PREPARATION_ORDER_RETURN_REQUEST',
  getPreparationOrderReturnRequest: createAction('order/GET_PREPARATION_ORDER_RETURN_REQUEST'),

  /**
   *  [주문상세] 반품 요청하기
   */
  SUBMIT_ORDER_RETURN_REQUEST: 'order/SUBMIT_ORDER_RETURN_REQUEST',
  SUBMIT_ORDER_RETURN_SUCCESS: 'order/SUBMIT_ORDER_RETURN_SUCCESS',
  orderReturnRequest: createAction('order/SUBMIT_ORDER_RETURN_REQUEST'),

  /**
   *  [주문상세] cs 메모 등록 요청하기
   */
  INSERT_ORDER_ITEM_CS_MEMO_REQUEST: 'order/INSERT_ORDER_ITEM_CS_MEMO_REQUEST',
  INSERT_ORDER_ITEM_CS_MEMO_SUCCESS: 'order/INSERT_ORDER_ITEM_CS_MEMO_SUCCESS',
  insertOrderItemCsMemoRequest: createAction('order/INSERT_ORDER_ITEM_CS_MEMO_REQUEST'),

  /**
   *  [주문상세] cs 메모 업데이트 요청하기
   */
  EDIT_ORDER_ITEM_CS_MEMO_REQUEST: 'order/EDIT_ORDER_ITEM_CS_MEMO_REQUEST',
  EDIT_ORDER_ITEM_CS_MEMO_SUCCESS: 'order/EDIT_ORDER_ITEM_CS_MEMO_SUCCESS',
  editOrderItemCsMemoRequest: createAction('order/EDIT_ORDER_ITEM_CS_MEMO_REQUEST'),

  /**
   *  [주문상세] 1:1 문의 리스트 요청하기
   */
  GET_ORDER_ITEM_CS_INQUIRY_LIST_REQUEST: 'order/GET_ORDER_ITEM_CS_INQUIRY_LIST_REQUEST',
  GET_ORDER_ITEM_CS_INQUIRY_LIST_SUCCESS: 'order/GET_ORDER_ITEM_CS_INQUIRY_LIST_SUCCESS',
  getOrderItemCsInquiryList: createAction('order/GET_ORDER_ITEM_CS_INQUIRY_LIST_REQUEST'),

  /**
   *  [주문상세] 1:1 문의 리스트 엑셀 다운로드 요청하기
   */
  GET_ORDER_ITEM_CS_INQUIRY_LIST_EXCEL_DOWNLOAD_REQUEST: 'order/GET_ORDER_ITEM_CS_INQUIRY_LIST_EXCEL_DOWNLOAD_REQUEST',
  getOrderItemCsInquiryListExcelDownload: createAction('order/GET_ORDER_ITEM_CS_INQUIRY_LIST_EXCEL_DOWNLOAD_REQUEST'),

  /**
   *  [주문상세] 상품 문의 리스트 요청하기
   */
  GET_ORDER_ITEM_CS_QNA_LIST_REQUEST: 'order/GET_ORDER_ITEM_CS_QNA_LIST_REQUEST',
  GET_ORDER_ITEM_CS_QNA_LIST_SUCCESS: 'order/GET_ORDER_ITEM_CS_QNA_LIST_SUCCESS',
  getOrderItemCsQnaList: createAction('order/GET_ORDER_ITEM_CS_QNA_LIST_REQUEST'),

  /**
   *  [주문상세] 상품 문의 리스트 엑셀 다운로드 요청하기
   */
  GET_ORDER_ITEM_CS_QNA_LIST_EXCEL_DOWNLOAD_REQUEST: 'order/GET_ORDER_ITEM_CS_QNA_LIST_EXCEL_DOWNLOAD_REQUEST',
  getOrderItemCsQnaListExcelDownload: createAction('order/GET_ORDER_ITEM_CS_QNA_LIST_EXCEL_DOWNLOAD_REQUEST'),

  /**
   * 모달 토글
   */
  TOGGLE_MODAL: 'order/TOGGLE_MODAL',
  toggleModal: createAction('order/TOGGLE_MODAL'),

  RESET_ORDER_ALL_LIST: 'order/RESET_ORDER_ALL_LIST',
  resetOrderAllList: createAction('order/RESET_ORDER_ALL_LIST'),
};

export default actions;
